export const getAuthUrl = me => {
  if (me) {
    return `${window.location.origin}/gateway`;
  } else {
    return `https://accounts.spotify.com/login?continue=${encodeURIComponent(
      `${window.location.origin}/gateway`,
    )}`;
  }
};
